import * as types from "../constants";

const initialState = {
  isLoading: true,
  error: null,
  items: [],
};

export default function reportsCreateReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_REPORTS_CREATE_INIT:
      return { ...state, error: null, isLoading: true };

    case types.GET_REPORTS_CREATE_SUCCESS:
      return { ...state, isLoading: false, items: action.data.data };

    case types.GET_REPORTS_CREATE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    default:
      return state;
  }
}
